import {tokenLoginApi} from "static/js/service/userService";
import {getParameter} from "static/js/Common2";

const PrivateRouteV2 = ({ children }) => {
  let url = window.location.href
  let urlList = url.split("?")

  // 자동 로그인 이벤트
  let getToken = getParameter("token");
  let getUserId = getParameter("userId");
  let getUserType = getParameter("userType");

  if(getToken) {
    tokenLoginApi(getUserId, getUserType, getToken, urlList[0]);
  } else {
    const keepChk = window.localStorage.getItem("keepChk");
    const userId = JSON.parse(keepChk === null ? window.sessionStorage.getItem("userId") : window.localStorage.getItem("userId"));
    const isAuthenticated = userId !== null

    return isAuthenticated ? children : window.location.href = "/";
  }
};

export default PrivateRouteV2;
